/**
 * Production-safe logging utility for frontend
 * Only logs in development mode
 */

const isProduction = process.env.NODE_ENV === 'production';
const isDebugMode = process.env.REACT_APP_DEBUG_LOGS === 'true';
const shouldLog = !isProduction || isDebugMode;

// Override global console.log if in production
if (isProduction && !isDebugMode) {
  console.log = () => {}; // Silent in production
  console.info = () => {}; // Silent in production  
  console.warn = () => {}; // Silent in production
  // Keep console.error for critical issues
}

const logger = {
  log: (...args) => {
    if (shouldLog) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, even in production
    console.error(...args);
  },
  
  warn: (...args) => {
    if (shouldLog) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (shouldLog) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (shouldLog) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  // Force log even in production (for critical info)
  forceLog: (...args) => {
    console.error('[FORCE]', ...args);
  }
};

export default logger;
